
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface DatabaseErrorAlertProps {
  onRetry?: () => void;
}

const DatabaseErrorAlert = ({ onRetry }: DatabaseErrorAlertProps) => {
  return (
    <Alert variant="destructive" className="mx-4 my-2">
      <div className="flex-1">
        <AlertTitle>Database Error</AlertTitle>
        <AlertDescription className="space-y-2">
          <p>
            There was an error connecting to the email database. Mock data will be used instead.
            Some email features may have limited functionality.
          </p>
          <div className="mt-3">
            <Button 
              variant="outline" 
              size="sm" 
              className="bg-destructive/10"
              onClick={onRetry}
            >
              <RefreshCw className="h-3 w-3 mr-2" />
              Retry Connection
            </Button>
          </div>
        </AlertDescription>
      </div>
    </Alert>
  );
};

export default DatabaseErrorAlert;
